import { useContext } from "react";
import { ColorTokens, XStack, YStack } from "tamagui";

import { LayoutContext } from "@/components/LayoutProvider";
import { Link, Text } from "@/components/Typography";
import { usePrivacySettingsExperience } from "@/hooks/privacySettings";

export default function LegalDisclaimer({
  backgroundColor = "$fillCuraiSubtle",
  showPromoDisclaimer = false,
}: {
  backgroundColor?: ColorTokens | null;
  showPromoDisclaimer?: boolean;
}) {
  const { lg } = useContext(LayoutContext);
  const { showPrivacySettingsExperience } = usePrivacySettingsExperience();
  return (
    <YStack backgroundColor={backgroundColor ?? undefined}>
      <YStack
        maxWidth="$landingPageConstraint"
        alignSelf="center"
        paddingHorizontal="$250"
        paddingVertical="$800"
        width="100%"
        gap="$250"
        borderTopWidth={1}
        borderTopColor="$borderColor"
      >
        <YStack gap="$100">
          <Text size="$xs" lineHeight="$sm" color="$textSecondary">
            Curai Health is a nationwide virtual care platform that connects
            patients with licensed clinicians. Clinical services are provided by
            Curai Health Medical Group, a professional medical group that does
            business as "Curai Health." Curai Health Medical Group is
            responsible for delivering medical services, including evaluation,
            diagnosis, and treatment. Curai Health Medical Group operates in
            multiple states through affiliated professional entities where
            required by state law. The specific Curai Health Medical Group
            entity that provides your care depends on your location at the time
            of service. Curai Health, Inc. is headquartered at 2443 Fillmore St.
            #380-15799, San Francisco, CA 94114.
          </Text>
          {showPromoDisclaimer && (
            <Text size="$xs" lineHeight="$sm" color="$textSecondary">
              † Promotional free visits are not available to individuals
              enrolled in Medicare or Medicaid.
            </Text>
          )}
        </YStack>
        <XStack gap="$75" flexDirection={lg ? "row" : "column"}>
          <Text size="$xs" color="$textSecondary">
            © {new Date().getFullYear()} Curai Health. All rights reserved.
          </Text>
          <Link href="/terms" size="$xs">
            Terms and Conditions
          </Link>
          {lg && (
            <Text size="$xs" color="$textSecondary">
              |
            </Text>
          )}
          <Link href="/privacy" size="$xs">
            Privacy Policy
          </Link>
          {lg && (
            <Text size="$xs" color="$textSecondary">
              |
            </Text>
          )}
          <Link
            size="$xs"
            href="#"
            onPress={() => {
              showPrivacySettingsExperience();
            }}
          >
            Consent Preferences
          </Link>
          {lg && (
            <Text size="$xs" color="$textSecondary">
              |
            </Text>
          )}
          <Link
            size="$xs"
            href="https://www.legitscript.com/websites/curaihealth.com/"
            external
          >
            LegitScript Certified
          </Link>
        </XStack>
      </YStack>
    </YStack>
  );
}
